<div class="wrapper" *ngIf="!!activeVehicle">
  <ng-container *ngFor="let menuItem of menuItems">
    <div class="button" (click)="navigate(menuItem.route, vehicleId)">
      <p>
        {{ menuItem?.name | translate }}
      </p>
    </div>
  </ng-container>
</div>
